import React from "react";
import styles from "./index.module.less";

function AIBannedInput() {
  return <div className={styles["ai-banned-input-container"]} />;
}

export default AIBannedInput;
